import { logEvent as firebaseLogEvent } from 'firebase/analytics';
import { analytics } from './firebase';

async function log(event: string, params?: Record<string, string | number | boolean>) {
  const a = await analytics;
  if (a) firebaseLogEvent(a, event, params);
}

export const Analytics = {
  logFeed: (feedType: 'bottle' | 'breastfeed', detail: { amount?: number; duration?: number }) =>
    log('log_feed', { feed_type: feedType, ...(detail.amount != null && { amount_ml: detail.amount }), ...(detail.duration != null && { duration_min: detail.duration }) }),

  logSleep: (durationMin: number, stillSleeping: boolean) =>
    log('log_sleep', { duration_min: durationMin, still_sleeping: stillSleeping }),

  logDiaper: (diaperType: 'pee' | 'poop' | 'both') =>
    log('log_diaper', { diaper_type: diaperType }),

  logGrowth: (metrics: string[]) =>
    log('log_growth', { metrics_logged: metrics.join(','), metrics_count: metrics.length }),

  addBaby: () =>
    log('add_baby'),

  inviteCaregiver: (role: string) =>
    log('invite_caregiver', { role }),
};
